import { useQuery } from '@tanstack/react-query';
import { monitoringCheckPageSchema, type MonitoringCheck } from '@bekebi/contracts/api';
import { apiRequest } from '../../api/client';
import { monitoringKeys } from '../monitoring/api';

/**
 * Dashboard data that no existing hook covers: every monitoring check (bounded), read from the
 * existing GET /api/monitoring/checks. Status and staleness are the API's own; the Dashboard only
 * picks out the checks the API reports as failed, warning or stale.
 */
export function useAllChecks(enabled: boolean) {
  return useQuery({
    queryKey: [...monitoringKeys.all, 'all-checks'],
    queryFn: async (): Promise<MonitoringCheck[]> => {
      const items: MonitoringCheck[] = [];
      let cursor: string | null = null;
      for (let page = 0; page < 20; page += 1) {
        const params = new URLSearchParams({ limit: '100' });
        if (cursor) params.set('cursor', cursor);
        const result = await apiRequest(`/monitoring/checks?${params}`, {
          schema: monitoringCheckPageSchema,
        });
        items.push(...result.items);
        cursor = result.nextCursor;
        if (!cursor) break;
      }
      return items;
    },
    enabled,
  });
}
